import { optionSetReducer } from './option-set.reducer';
import { checkpointReducer } from './checkpoint.reducer';
import { dateReducer } from './date.reducer';
import { defectiveComponentReplacementReducer } from './defective-component-replacement.reducer';
import { discrepancyLogReducer } from './discrepancy-log.reducer';
import { dropDownOptionsReducer } from './drop-down-options.reducer';
import { materialSerialNumberReducer } from './material-serial-number.reducer';
import { optionReducer } from './option.reducer';
import { remarksSectionReducer } from './remark-section.reducer';
import { remarksReducer } from './remarks.reducer';
import { replacementOrLastProcedureDateReducer } from './replacement-or-last-procedure-date.reducer';
import { selectionReducer } from './selection.reducer';
import { signatureReducer } from './signature.reducer';
import { valueReducer } from './value.reducer';
import { measuringEquipmentsReducer } from './measuring-equipments.reducer';

export const functionalElementsReducer = [
    ...valueReducer,
    ...optionReducer,
    ...selectionReducer,
    ...discrepancyLogReducer,
    ...replacementOrLastProcedureDateReducer,
    ...materialSerialNumberReducer,
    ...signatureReducer,
    ...checkpointReducer,
    ...dateReducer,
    ...defectiveComponentReplacementReducer,
    ...remarksReducer,
    ...remarksSectionReducer,
    ...optionSetReducer,
    ...dropDownOptionsReducer,
    ...measuringEquipmentsReducer,
];
